import { HistoryMovement } from 'types';
import { CustomRange } from '../types/CustomRange';

type GetHistoryMovementsProps = {
  editedRanges: CustomRange[];
  holdingClassName: string;
};

export const getHistoryMovements = ({
  editedRanges,
  holdingClassName,
}: GetHistoryMovementsProps): HistoryMovement[] => {
  const historyMovements = editedRanges.map((range: CustomRange) => ({
    from: range.from,
    to: range.to,
    holdingClassName: holdingClassName || '',
    newFrom: range.newFrom,
    newTo: range.newTo,
    newHoldingClassName: range.selectedShareClassOption?.label || '',
  }));

  return historyMovements;
};
